import OrderOptimizerCargoListingTableColumn from "../common/types/order-optimizer-cargo-listing-table-column";

const getColumns = (): OrderOptimizerCargoListingTableColumn[] => {
  const tableColumns: OrderOptimizerCargoListingTableColumn[] = [
    {
      header: "",
      title: "",
      accessor: "row",
    },
  ];
  return tableColumns;
};

const orderOptimizerCargoListingTableHelper = { getColumns };

export default orderOptimizerCargoListingTableHelper;
